export interface IMultiselectOption<V = string | number | boolean, L extends string = string> {
    label: L;
    value: V;
    group: string;
}
